import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { validateConfirmTokenAPI } from "../../API/endpoints/auth";
import SetPasswordCard from "../../components/auth/SetPasswordCard";
import classes from "../../components/auth/RegistrationStatus.module.scss";

export default function CompleteRegistration() {
  const [isLoading, setIsLoading] = useState(true);
  const [isLinkValid, setIsLinkValid] = useState();

  const [searchParams] = useSearchParams();
  const confirmToken = searchParams.get("token");

  useEffect(() => {
    const validateToken = async () => {
      try {
        const response = await validateConfirmTokenAPI(confirmToken);
        if (response.status === 204) setIsLinkValid(true);
      } catch {
        setIsLinkValid(false);
      } finally {
        setIsLoading(false);
      }
    };
    validateToken();
  }, [confirmToken]);

  return (
    <div>
      {isLoading ? (
        <p>Loading...</p>
      ) : isLinkValid ? (
        <SetPasswordCard title="Set password to complete registration" />
      ) : (
        <div className={classes.container}>
          <div className={classes.message}>This link is expired</div>
        </div>
      )}
    </div>
  );
}
